import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  getHerbicidesEconomy,
  PeriodType,
} from '@/services/get-herbicides-economy'

import { useCompanies } from '../use-companies'

export const GET_HERBICIDES_ECONOMY_QUERY = 'GET_HERBICIDES_ECONOMY_QUERY'

export const useGetHerbicidesEconomy = (period: PeriodType) => {
  const { selectedCompany } = useCompanies()
  const query = useQuery(
    [GET_HERBICIDES_ECONOMY_QUERY, period, selectedCompany?.id],
    ({ signal }) => getHerbicidesEconomy(period, { signal }),
    {
      staleTime: 1000 * 60 * 60, // 1 hora
      onError: () =>
        toast.error(
          'Não foi possível carregar as informações, tente novamente.',
        ),
    },
  )

  return query
}
